import React, { useContext } from 'react';
import type { WPublicNavItemView } from '@zola/svc-web-api-ts-client';
import styled from '@emotion/styled';
import { mapFontViewToSerializedStyles } from '../../../util/mappers';
import { ThemeContext } from '../../../context';

export type NavigationMenuProps = {
  navItems?: WPublicNavItemView[];
  slug?: string;
  className?: string;
};

const NavigationMenu = ({ navItems, slug, className }: NavigationMenuProps): JSX.Element => {
  const {
    header: {
      nav_item: { font },
    },
    // bg_color,
  } = useContext(ThemeContext);

  const { font_color } = font;

  const NAV_ITEM_PADDING_BOTTOM = 8;
  const NAV_ITEM_BORDER_WIDTH = 1;
  const activeStyle = font_color
    ? `
    color: ${font_color};
  border-bottom: ${NAV_ITEM_BORDER_WIDTH}px solid ${font_color};
  padding-bottom: ${NAV_ITEM_PADDING_BOTTOM - NAV_ITEM_BORDER_WIDTH}px;
  `
    : '';

  const NavItem = styled.a<{ active?: boolean }>`
    color: inherit;
    ${mapFontViewToSerializedStyles(font)}
    margin: 0 12px;
    padding-bottom: ${NAV_ITEM_PADDING_BOTTOM}px;
    &:hover {
      text-decoration: none;
      ${activeStyle}
    }
  `;
  const NavLinkContainer = styled.ul`
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: safe center;
    text-align: center;
  `;
  const NavContainer = styled.div`
    position: sticky;
    top: 0;
    padding-top: 20px;
    padding-bottom: 20px;
  `;

  return (
    <NavContainer className={className}>
      <NavLinkContainer>
        {(navItems || []).map(({ type, nav_title }) =>
          type ? (
            <NavItem href={`/wedding-test/${slug}/${((type as unknown) as string).toLowerCase()}`}>
              {nav_title}
            </NavItem>
          ) : null
        )}
      </NavLinkContainer>
    </NavContainer>
  );
};

export default NavigationMenu;
